import { Product } from './product';

export class ShoppingCartItem {
    key: string;
    title: string;
    imageUrl: string;
    price: number;

    constructor(public product: Product, public quantity: number) {

}
    get totalPrice() {
        return this.product.price * this.quantity; 
    }
} 